import { parsePokeNameForSprite } from "utils/pokemon/name-utils";
import { S3_BASE_URL } from "@/utils/s3";

/**
 * Full-art illustration URL for a species, resolved from CDN.
 * Normal and shiny variants are stored at:
 *   pokemons/{parsedName}/full-art.png
 *   pokemons/{parsedName}/full-art-shiny.png
 *
 * Returns undefined for empty names. A CDN 404 (species not yet uploaded)
 * degrades gracefully — the blurred backdrop simply doesn't render.
 */
export const getFullArtUrl = (baseName: string, isShiny?: boolean): string | undefined => {
  if (!baseName) return undefined;
  const file = isShiny ? "full-art-shiny.png" : "full-art.png";
  return `${S3_BASE_URL}/pokemons/${parsePokeNameForSprite(baseName)}/${file}`;
};
